import React from 'react'
import SliderNewsAdvertisement from '../../component/slidercomponent/SliderOurTeam'

const NewsAdvertisement = () => {
    return (
        <>
            <section className="choose-us-section-2 section-padding fix">
                <div className="pen-shape float-bob-y">
                    <img src="assets/img/shape/mark-pen.png" alt="img" />
                </div>
                <div className="container">
                    <div className="section-title text-center">
                        <span className="sub-title wow fadeInUp">Why Choose Us</span>
                        <h2 className="wow fadeInUp" data-wow-delay=".3s" style={{fontSize:"32px"}}>
                            Our Learning Principles at these Stages are Guided by:
                        </h2>
                    </div>
                    <div className="choose-us-wrapper-2">
                        <div className="row g-4 align-items-center">
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="choose-us-item">
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="content">
                                            <h3 style={{fontSize:"17px"}}>Experiential learning</h3>
                                            <p>
                                                the purpose of learning through hands-on activities and maker spaces.
                                            </p>
                                        </div>
                                        <div className="icon">
                                            <i className="flaticon-chapter" />
                                        </div>
                                    </div>
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="content">
                                            <h3 style={{fontSize:"17px"}}>Exploration</h3>
                                            <p>
                                                building on the natural curiosity of the child and enabling them to question and investigate.
                                            </p>
                                        </div>
                                        <div className="icon">
                                            <i className="flaticon-learning" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Our Learning.webp" alt="img" className="wow img-custom-anim-top" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                    <div className="mask-shape">
                                        <img src="assets/img/shape/mask-shape.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="choose-us-item style-2">
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="icon">
                                            <i className="flaticon-watching-a-movie" />
                                        </div>
                                        <div className="content style-2">
                                            <h3 style={{fontSize:"17px"}}>Emotional experience</h3>
                                            <p>
                                                build on the capacities to learn and make them life-long learners.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="icon">
                                            <i className="flaticon-abstract" />
                                        </div>
                                        <div className="content style-2">
                                            <h3 style={{fontSize:"17px"}}>Environment of belonging</h3>
                                            <p>
                                                making learning meaningful by creating paths towards sustained growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default NewsAdvertisement